import { createFileRoute } from "@tanstack/react-router"
import { Card } from "@/components/ui/card"
import { WaitlistForm } from "@/components/waitlist-form"

function Waitlist() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 py-12">
      <a href="https://yomimono.ai">
        <img src="/logo_full.svg" alt="Yomimono" className="mb-8 h-10" />
      </a>

      <Card className="w-full max-w-sm">
        <WaitlistForm />
      </Card>
    </div>
  )
}

export { Waitlist }
export const Route = createFileRoute("/waitlist")({
  component: Waitlist,
})
